import { NgStyle } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractTailoredTemplateWidget } from '../AbstractTailoredWidgetTemplate.class';

@Component({
    styleUrls: ['./template-widget-custom-image.scss'],
    selector: 'template-widget-custom-image',
    templateUrl: 'template-widget-custom-image.html',
    imports: [NgStyle]
})
export class TemplateWidgetCustomImageComponent extends AbstractTailoredTemplateWidget<{
    url: string;
    displayType?: string;
    backgroundColor?: string;
}> {}
